import React from 'react';
// import logo from "../../assets/Images/logoWhite.png"
// import "./Footer.css"
// import { Link } from "react-router-dom"

// import { FaFacebook, FaTwitter, FaInstagramSquare, FaLinkedin, FaArrowRight } from "react-icons/fa";

const Footer = () => {
    return (
        <></>
        // <div className='footer'>
        //     <footer className="py-5 px-2">
        //         <div className="container">
        //             <div className="row">
        //                 <div className="col-md-4 ">
        //                     <h2 className='py-4'>Cura Bangladesh</h2>
        //                     <p className='px-2'>Cura Bangladesh is concerned with bringing the ultimate ease in your life - be it traveling or healing.</p>
        //                 </div>

        //                 <div className="col-md-3">
        //                     <h4 className='py-4'>Office</h4>
        //                     <div className="d-flex align-items-py-4center">
        //                         <i class="fa-solid fa-location-dot me-2  "></i>
        //                         <p className=''>House 78, Road 11A, Dhanmondi <br /> R/A, Dhaka 1209</p>
        //                     </div>
        //                     <div className="d-flex align-items-center">
        //                         <i class="fa-solid fa-earth-americas me-2"></i>

        //                         <p>curabangladesh.com</p>
        //                     </div>
        //                     <div className="d-flex align-items-center">
        //                         <i class="fa-solid fa-phone me-2"></i>

        //                         <p>+01323-581330-34</p>
        //                     </div>


        //                 </div>
        //                 <div className="col-md-2 ">
        //                     <h4 className='py-4'>Links</h4>
        //                     <div>

        //                         <Link to="/home" style={{ textDecoration: "none", color: "currentColor" }}><p>Home</p></Link>
        //                         <Link to="/hospital" style={{ textDecoration: "none", color: "currentColor" }}><p>Hospitals</p></Link>
        //                         <Link to="/hotel" style={{ textDecoration: "none", color: "currentColor" }}><p>Hotels</p></Link>
        //                         <Link to="/contact" style={{ textDecoration: "none", color: "currentColor" }}><p>Contact</p></Link>
        //                         {/* <Link to="/form" style={{ textDecoration: "none", color: "currentColor" }}><p>Form</p></Link> */}
        //                     </div>
        //                 </div>
        //                 <div className="col-md-2 ">
        //                     <h4 className='py-4'>Newsletter</h4>
        //                     {/* <div className="row py-3 subscriber">
        //                         <input type="text" placeholder='Your email' className='form-control' />
        //                         <FaArrowRight className="right_arrow" />
        //                     </div> */}
        //                     <div className='row'>
        //                         <div className='col-md-3 p-2'>
        //                             <FaFacebook />
        //                         </div>
        //                         <div className='col-md-3 p-2'>
        //                             <FaTwitter />
        //                         </div>
        //                         <div className='col-md-3 p-2'>
        //                             <FaInstagramSquare />
        //                         </div>
        //                         <div className='col-md-3 p-2'>
        //                             <FaLinkedin />
        //                         </div>
        //                     </div>
        //                 </div>


        //             </div>

        //         </div>

        //     </footer>
        //     <div className='d-flex justify-content-center p-2 text-center'>
        //         <p class="">2022 	&copy; all right reserved by Cura Bangladesh | Designed and Developed by <a href="https://www.ongshak.com/" target="_blank" style={{ textDecoration: "none", color: "currentColor" }}
        //         >Ongshak</a>
        //         </p>
        //     </div>
        // </div>
    );
};

export default Footer;